import { render } from "./AddComputer.vue?vue&type=template&id=65d9a2a7&scoped=true&ts=true"
import script from "./AddComputer.vue?vue&type=script&lang=ts"
export * from "./AddComputer.vue?vue&type=script&lang=ts"

import "./Computers.scss?vue&type=style&index=0&id=65d9a2a7&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d9a2a7"]])

export default __exports__